import apiFetch from '@wordpress/api-fetch';
import { Schedule } from '../models/schedule';

export async function getScheduleData(): Promise<Schedule[]> {
	const response: any[] = await apiFetch({
		path: '/bookr/v1/schedule',
		method: 'GET',
	});

	const schedules: Schedule[] = response.map((res) => {
		return {
			id: res.id,
			weekday: res.weekday,
			enabled: res.enabled === '1' ? true : false,
			startTime: res.start_time,
			endTime: res.end_time,
			defaultDuration: res.default_duration,
		};
	});

	return schedules;
}

export async function updateSchedule(schedules: Schedule[]): Promise<Schedule[]> {
	const bodyData = schedules.map((schedule) => {
		return {
			id: schedule.id,
			weekday: schedule.weekday,
			enabled: schedule.enabled,
			start_time: schedule.startTime,
			end_time: schedule.endTime,
			default_duration: schedule.defaultDuration,
		};
	});

	const response: any = await apiFetch({
		path: '/bookr/v1/save-schedule',
		method: 'POST',
		data: bodyData,
	});

	return response.data;
}
